import formReducer, {
  emptySelectField,
  emptySingleInputField,
  formHelperMethodFactory,
} from 'reducers/FormReducer/FormReducer'
import {
  BaseValidationField,
  createFormField,
  FormReducerSelectField,
  FormReducerSingleTextField,
  PickByType,
  ValidationObject,
  withValidationFactory,
} from 'reducers/FormReducer/utils'
import type { ProjectsDetailResult } from '@contracts'

export interface ProjectFormReducerState {
  project_name: FormReducerSingleTextField
  client_id: FormReducerSelectField
  brand_id: FormReducerSelectField
}

type PickProjectStateField<T> = PickByType<ProjectFormReducerState, T>

// Define the keys of the fields that match the correct element types
export type NewProjectInputField = PickProjectStateField<FormReducerSingleTextField>
export type NewProjectSelectField = PickProjectStateField<FormReducerSelectField>

// Get the keys of the fields that have a value and an error field
export type NewProjectValidationFields = BaseValidationField<ProjectFormReducerState>

export const defaultNewProjectErrorObject: ValidationObject<'ProjectFormReducerState'> = {}
const withValidation = withValidationFactory(defaultNewProjectErrorObject)

// Define the initial state of the form
export const emptyProjectFormReducerState: ProjectFormReducerState = {
  project_name: withValidation(emptySingleInputField, 'project_name', ['requiredField'], []),
  client_id: withValidation(emptySelectField, 'client_id', ['requiredField'], []),
  brand_id: withValidation(emptySelectField, 'brand_id', ['requiredField'], []),
}

export const initialProjectFormReducerState = (data: ProjectsDetailResult): ProjectFormReducerState => ({
  project_name: withValidation(createFormField('text', data.project_name || ''), 'project_name', ['requiredField'], []),
  client_id: withValidation(createFormField('text', data.client_id || ''), 'client_id', ['requiredField'], []),
  brand_id: withValidation(createFormField('text', data.brand_id || ''), 'brand_id', ['requiredField'], []),
})

const projectFormReducer = formReducer<'ProjectFormReducerState'>
export const projectFormHelperFunctions = formHelperMethodFactory<'ProjectFormReducerState'>()
export default projectFormReducer
